import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Container } from 'components/core/Page';
import { Image } from 'components/core/Image';
import { Tooltip } from 'components/core/Tooltip';
import './TopBanner.scss';

const TopBanner = ({className,title, content, icon, tooltipMessage, tooltipIcon, iconAlt }) => (
	<Container className={classnames('top-banner', className)}>
		{icon && <Image src={icon} className="top-banner__icon" alt={iconAlt} />}
		<div className='top-banner__text'>
			<span className='top-banner__title'>{title}</span>
			<span>{content}</span>
		</div>
		{tooltipMessage && tooltipIcon && (
			<Tooltip 
				className="tooltip" 
				content={tooltipMessage}
				tooltipIcon={<Image src={tooltipIcon} className="top-banner__tooltip-icon" alt="tooltip icon"/>}
				iconRightSide
				clickOnMobile
				plainText
				fillParentContainer="right"
				hideTooltipForLarge={false}
				size="normal"
			>
				<span className="tooltip-trigger-text"> </span>
			</Tooltip>
		)}	
	</Container>
);

TopBanner.propTypes = {
	className: PropTypes.string,
	content: PropTypes.any,
	icon: PropTypes.string,
	iconAlt: PropTypes.string,
	tooltipIcon: PropTypes.string,
	tooltipMessage: PropTypes.string
};

TopBanner.defaultProps = {
	className: '',
};

export default TopBanner;
